<template>
  <div class="course-rate">
    <div class="course-rate-title">{{isCourse ? '热门课程' : '推荐文章'}}</div>
    <div class="course-rate-item" v-for="(item, index) in courses" :key="item._id" @click="goPage(item._id)">
      <span :style="{color: getColor(index)}" class="course-rate-item-nums">0{{index + 1}}</span>
      <span class="course-rate-item-title" :title="item.title">{{item.title}}</span>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'course-rate',
  props: {
    courses: { // 数据源
      type: Array
    },
    isCourse: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getColor (index) {
      const colors = ['#FFD146', '#CBD8E0', '#D68A58']
      return index > 2 ? '#EAEAEA' : colors[index]
    },
    goPage (_id) {
      let url = (this.isCourse ? '/coursedetail/' : '/p/') + _id
      window.open(url)
    }
  },
  created () {
    console.log(this.courses)
  }
}
</script>
<style lang="scss" scoped>
.course-rate {
  width: 280px;
  text-align: left;
  >.course-rate-title{
    height: 53px;
    font-family:MicrosoftYaHei-Bold;
    font-size: 16px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:53px;
    border-bottom: 1px solid rgba(234,234,234,1);
    margin-bottom: 16px;
  }
  >.course-rate-item {
    font-size: 14px;
    color:rgba(51,51,51,1);
    line-height:40px;
    height: 40px;
    display: flex;
    &:hover {
      cursor: pointer;
      font-weight: bold;
    }
    >.course-rate-item-nums{
      font-family:HYk1gj;
      font-size: 16px;
    }
    >.course-rate-item-title {
      margin-left: 12px;
      display: inline-block;
      width: 240px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

}
</style>